// Projects data lives in JSON (editable by humans, scripts, n8n).
// Validated against ProjectsSchema at module load.
import { ProjectsSchema, type Projects } from '@lib/schemas/project';
import data from './data/projects.json';

export const projects: Projects = ProjectsSchema.parse(data);
